import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BrandingProvider } from "@/context/BrandingContext";
import { AuthProvider } from "@/context/AuthContext";
import PortalPage from "@/pages/PortalPage";
import PrivacyPage from "@/pages/PrivacyPage";
import LoginPage from "@/pages/admin/LoginPage";
import AdminLayout from "@/components/admin/AdminLayout";
import RequestsPage from "@/pages/admin/RequestsPage";
import AppointmentsPage from "@/pages/admin/AppointmentsPage";
import MessagesPage from "@/pages/admin/MessagesPage";
import BrandingPage from "@/pages/admin/BrandingPage";
import AuditPage from "@/pages/admin/AuditPage";
import SecurityPage from "@/pages/admin/SecurityPage";
import FeaturesPage from "@/pages/admin/FeaturesPage";

function App() {
  return (
    <BrandingProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortalPage />} />
          <Route path="/privacidade" element={<PrivacyPage />} />
          <Route path="/admin/login" element={<AuthProvider><LoginPage /></AuthProvider>} />
          <Route path="/admin" element={<AuthProvider><AdminLayout /></AuthProvider>}>
            <Route index element={<RequestsPage />} />
            <Route path="agendamentos" element={<AppointmentsPage />} />
            <Route path="configuracoes/mensagens" element={<MessagesPage />} />
            <Route path="configuracoes/marca" element={<BrandingPage />} />
            <Route path="funcionalidades" element={<FeaturesPage />} />
            <Route path="auditoria" element={<AuditPage />} />
            <Route path="seguranca" element={<SecurityPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors closeButton />
    </BrandingProvider>
  );
}

export default App;
